import { Component, Input } from "@angular/core";

@Component({
    selector: 'text-truncate-popover',
    template: `
    <span *ngIf="text?.length <= maxLength">{{text}}</span>
    <span *ngIf="text?.length < 1">-</span>
    <span
            *ngIf="text?.length > maxLength"
            [ngbPopover]="text"
            placement="top"
            [popoverTitle]="popoverTitle"
            triggers="mouseenter:mouseleave"
            container="body"
    >
      {{text| truncate: maxLength}}
    </span>
  `,
    standalone: false
})
export class TextTruncatePopoverComponent {

  @Input('text') text: string | undefined;
  @Input('popoverTitle') popoverTitle: string | undefined;
  @Input('maxLength') maxLength: number = 50;

}
